import * as React from 'react';
import {ImageStyle, Platform, StyleSheet, View, ViewStyle} from 'react-native';

import FastImageAdapter from '../../../../../shared/fast_image/FastImageAdapter';

import {illustrationImageUrl} from '../../../../../../helpers/images';

import Illustration from '../../../../../../../domain/entities/Illustration';

const RESIZE_MODE = 'contain';
const IMAGE_SIZE = 'large';
const headers = {Accept: 'image/webp,image/apng,*/*'};

interface Props {
  illustration: Illustration;
  children?: React.ReactNode;
}

const IllustrationView: React.FunctionComponent<Props> = props => {
  const {illustration} = props;
  return (
    <View style={styles.container}>
      <FastImageAdapter
        resizeMode={RESIZE_MODE}
        style={styles.image}
        source={{
          uri: illustrationImageUrl(illustration, IMAGE_SIZE),
          headers,
        }}
      />
    </View>
  );
};

export default React.memo(IllustrationView);

const width = 200;
const height = 200;
const aspectRatio = width / height;

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    width: '100%',
    height,
    margin: 5,
    ...Platform.select({
      web: {
        userSelect: 'none',
        cursor: 'pointer',
      },
      default: {},
    }),
  } as ViewStyle,
  image: {
    aspectRatio,
    flex: 1,
    width,
    height,
  } as ImageStyle,
});
